import {
  EDiffPriceTrand,
  IGetMarketTrandResponseSchema,
} from 'shared/repositories/valuation-offer-history/entities/market_trand/GetMarketTrandResponseSchema';
import { IFilters } from './filters';
import { INearbyHousesInfo } from './nearbyHousesInfo';
import { TSupplyDemand } from './supplyDemand';
import { IAvailableFilters } from './filtersAvailability';

export { EDiffPriceTrand };

export interface ITrendsDatasetItem {
  value: number;
  reportDate: string | number;
  prettyValue: string;
}

export interface IMarketTrendsData extends Omit<Required<IGetMarketTrandResponseSchema>, 'marketTrand' | 'houseTrand'> {
  marketTrand: ITrendsDatasetItem[];
  houseTrand: ITrendsDatasetItem[];
}

export enum EMarketTrendsStatus {
  Initial = 'initial',
  Loading = 'loading',
  Loaded = 'loaded',
}

export interface IMarketTrends {
  nearbyHousesInfo: INearbyHousesInfo[];
  marketTrendsData: IMarketTrendsData | null;
  marketTrendsStatus: EMarketTrendsStatus;
  filters: IFilters;
  filtersAvailability: IAvailableFilters;
  supplyDemand: TSupplyDemand | null;
}
